import { atom } from "recoil";
import { UpdatePlaylistDto } from "../services";

export const PlaylistUpdateState = atom<UpdatePlaylistDto | null>({
  key: "playlistUpdateState",
  default: null,
});
